import React, { useState } from 'react';
import './CreateSnapshotDialog.css';

interface CreateSnapshotDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (description: string) => void;
  projectName: string;
}

const CreateSnapshotDialog: React.FC<CreateSnapshotDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  projectName,
}) => {
  const [description, setDescription] = useState('');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (!description.trim()) {
      alert('Prosím zadajte popis zálohy');
      return;
    }
    onConfirm(description);
    setDescription('');
    onClose();
  };

  const handleCancel = () => {
    setDescription('');
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleCancel}>
      <div className="modal-content create-snapshot-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>📸 Vytvoriť zálohu projektu</h2>
          <button className="close-button" onClick={handleCancel}>
            ✕
          </button>
        </div>

        <div className="modal-body">
          <div className="snapshot-info">
            <p><strong>Projekt:</strong> {projectName}</p>
            <p className="info-text">
              Záloha bude obsahovať kompletný stav projektu (stĺpiky, káble, ONUs, kazety).
            </p>
          </div>

          <div className="form-group">
            <label htmlFor="snapshot-description">
              Popis zálohy <span className="required">*</span>
            </label>
            <textarea
              id="snapshot-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Napr.: Záloha pred veľkou zmenou topológie"
              rows={3}
              autoFocus
            />
            <div className="char-count">{description.length} / 500</div>
          </div>

          <div className="snapshot-examples">
            <p className="examples-title">💡 Príklady:</p>
            <ul>
              <li>Záloha pred pridaním nového OLT</li>
              <li>Stav po dokončení inštalácie v oblasti XY</li>
              <li>Pred testovaním novej konfigurácie</li>
            </ul>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={handleCancel}>
            Zrušiť
          </button>
          <button className="btn-confirm" onClick={handleConfirm}>
            📸 Vytvoriť zálohu
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateSnapshotDialog;

